import '@angular/compiler';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PageMainComponent } from './page.main/page.main.component';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
    declarations: [
        AppComponent,
        AppComponent,
        LayoutMainComponent,
        PageMainComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
